'use strict';

import VZSpinner from 'Components/VZSpinner';
import { getUrlFromAttributes } from 'Util/urlUtils';

class VZFilter extends HTMLElement {
    constructor() {
        super();
        this.scope = null;
        this.excludedAttributes = ['class', 'data-configurator-type', 'data-url', 'data-general-error'];
    }

    connectedCallback() {
        this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
    }

    onChange() {
        this.applyFilter();
    }

    async applyFilter() {
        if (!this.scope) {
            this.scope = document.querySelector(`[data-scope="${this.getAttribute('scope')}"]`) || document;
        }

        const urlAttribute = this.getAttribute('url');
        const vZProductCard = this.closest('vz-product-card');

        if (urlAttribute != null && vZProductCard != null) {
            const spinner = document.querySelector('vz-spinner') || new VZSpinner();
            spinner.start();

            const url = getUrlFromAttributes(urlAttribute, vZProductCard, this.excludedAttributes);

            await fetch(url)
                .then((res) => res.text())
                .then((res) => {
                    const productCard = this.closest('vz-product-card') || document.querySelector('vz-product-card');
                    productCard.dispatchEvent(
                        new CustomEvent('variationChange', {
                            detail: {
                                response: res
                            }
                        })
                    );
                    document.getElementById('product-configurator').dispatchEvent(new CustomEvent('variationChange'));
                    document.getElementById('product-configurator').dispatchEvent(new CustomEvent('pdp:filter'));
                });
            spinner.stop();
        }

        this.scope.setAttribute('data-active-filter', this.getAttribute('for'));
    }
}

if (!window.customElements.get('vz-filter')) {
    window.customElements.define('vz-filter', VZFilter);
}
